import React from 'react';

interface DisclaimerNoteProps {
  menuWidth?: number;
}

export const DisclaimerNote: React.FC<DisclaimerNoteProps> = ({ menuWidth = 90 }) => {
  return (
    <div 
      className="fixed bottom-0 bg-[var(--main-background)] text-gray-600 dark:text-gray-400 text-xs px-4 py-2 text-center"
      style={{
        left: `${menuWidth}px`,
        right: '12px',  // Match ChatInput positioning to cover scrollbar
        zIndex: 100     // Match ChatInput z-index to appear in front of scrollbar
      }}
    >
      Note: Generative AI agents may produce inaccurate information about people, places, or facts.
    </div>
  );
};